import { useEffect } from "react";
const PIXEL_ID = "1591693235820229";
export function trackMetaEvent(eventName: "PageView" | "InitiateCheckout") {
  if (typeof window === "undefined") return;
  const pixel = new Image();
  pixel.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=${eventName}&noscript=1&r=${Date.now()}`;
}
export function MetaPixel() {
  useEffect(() => {
    trackMetaEvent("PageView");
  }, []);
  return null;
}